// extracted by mini-css-extract-plugin
export var IconButton = "notifications-styles-module--IconButton--aa725";
export var PopoverArrow = "notifications-styles-module--PopoverArrow--90b98";
export var PopoverClose = "notifications-styles-module--PopoverClose--1ff75";
export var PopoverContent = "notifications-styles-module--PopoverContent--0c562";
export var badge = "notifications-styles-module--badge--33628";
export var slideDownAndFade = "notifications-styles-module--slideDownAndFade--08917";
export var slideLeftAndFade = "notifications-styles-module--slideLeftAndFade--595ea";
export var slideRightAndFade = "notifications-styles-module--slideRightAndFade--f6415";
export var slideUpAndFade = "notifications-styles-module--slideUpAndFade--d4fe4";